export default "__VITE_ASSET__D1PmL1bS__"